import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { T } from '../../../../Translations';
import Logo from '../../../Cutesies/Logo';

const PlatformLogo: React.FC<{}> = () => {
  return (
    <div
      className={clsx(
        'block h-[65px] py-2 pb-4 px-5 lg:mr-[30px] lg:h-[21px] lg:px-0',
        'border-b-2 border-solid border-teal-600 lg:mb-2 lg:border-none lg:py-0',
      )}
      data-test-platform-logo={true}
    >
      <NavLink to="/" className="block h-[100%] w-[215px] lg:inline-block lg:h-[23px] lg:w-[145px]">
        <Logo />
        <span className="absolute -top-2.5 h-px w-px overflow-hidden">
          <T kind="Go to Learning Collections" />
        </span>
      </NavLink>
    </div>
  );
};
export default observer(PlatformLogo);
